"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtbxDaily = void 0;
const rtbxInterval_1 = require("./rtbxInterval");
class RtbxDaily extends rtbxInterval_1.RtbxInterval {
    static deserialize(params = {}) {
        return new RtbxDaily(params);
    }
    constructor(params = {}) {
        super(params);
    }
    diff() {
        let diff = {};
        if (this.impsAdjDiff()) {
            diff.impsAdj = this.impsAdj;
        }
        if (this.revAdjDiff()) {
            diff.revAdj = this.revAdj;
        }
        return diff;
    }
}
exports.RtbxDaily = RtbxDaily;
//# sourceMappingURL=rtbxDaily.js.map